import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';
import type { PodFilterValue } from 'infrastructure/interfaces';
import type { TCCMDataFilters } from 'infrastructure/hooks/ccm/console/use-ccm-data-query-filter';

export interface IPodFilterProps {
  value?: PodFilterValue;
  updateFilter: (newFilter: Partial<TCCMDataFilters>) => void;
}

export const PodFilter: FC<IPodFilterProps> = ({
  value = 'all',
  updateFilter,
}) => {
  const { t } = useTranslation();

  const options = [
    { value: 'all', label: t('labels.allPod', 'All Pod') },
    { value: 'primary', label: t('labels.primaryPod', 'Primary Pod') },
    { value: 'secondary', label: t('labels.secondaryPod', 'Secondary Pod') },
    { value: 'tertiary', label: t('labels.tertiaryPod', 'Tertiary Pod') },
    { value: 'outside', label: t('labels.outsidePod', 'Outside Pod') },
  ];

  return (
    // data-cy goes on the WRAPPER div — NOT on <Select>
    // Ant Design Select v5 does not forward arbitrary HTML attributes to the DOM element
    <div data-cy="ccm-console-select-pod">
      <div className={s['select-label']}>
        <Select
          value={value}
          options={options}
          className={s['select-pod']}
          onChange={(v: PodFilterValue) => {
            updateFilter({
              podFilter: v === 'all' ? undefined : v,
              'n-page': undefined,
              'f-page': undefined,
              'p-page': undefined,
            });
          }}
        />
      </div>
    </div>
  );
};
